<script lang='ts'>
import { reactive, defineComponent, onMounted } from '@vue/composition-api';
//@ts-ignore
import * as $ from 'jquery';

interface IProps {
    value: string;
}

const AppRecaptcha = defineComponent({
    name: 'AppRecaptcha',
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const state = reactive({});

        const render = () => {
            if ($('#captcha-container').length > 0) {
                if ($('#captcha-container iframe').length > 0) {
                    grecaptcha.reset();
                } else {
                    grecaptcha.render('captcha-container', {
                        sitekey: initAppData.captchaSiteKey,
                        callback: addCaptchaToken,
                    });
                }
            }
        };

        const addCaptchaToken = (token: string) => {
            ctx.emit('input', token);
            $('#captcha-validation-message').css('display', grecaptcha.getResponse() ? 'none' : 'block');
        };

        //@ts-ignore
        window['renderCaptcha'] = render;

        onMounted(() => {
            if (typeof grecaptcha != 'undefined') {
                render();
            } else {
                //@ts-igonre
                $.getScript('https://www.google.com/recaptcha/api.js?onload=renderCaptcha&render=explicit');
            }
        });

        return {
            state,
        };
    },
});

export default AppRecaptcha;
</script>

<template>
  <div>
    <div id="captcha-container" class="control" />
    <div id="captcha-validation-message" class="field-validation-error">
      Please solve the Captcha
    </div>
  </div>
</template>

<style lang='scss' scoped></style>